/**
 * Pre-compiled localized messages for PasswordInput component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import passwordInputMessages_en from "./intl/en";
import passwordInputMessages_de from "./intl/de";
import passwordInputMessages_es from "./intl/es";
import passwordInputMessages_fr from "./intl/fr-FR";
import passwordInputMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const passwordInputMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(passwordInputMessages_en),
  de: normalizeMessages(passwordInputMessages_de),
  es: normalizeMessages(passwordInputMessages_es),
  "fr-FR": normalizeMessages(passwordInputMessages_fr),
  "pt-BR": normalizeMessages(passwordInputMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for PasswordInput component
 */
export type PasswordInputMessageKey = "hide" | "show";
